exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-placeholder-page{margin-top:0}.help-placeholder-message{margin:0;color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/help/help.placeholder.component.css
// module id = 1522
// module chunks = 0